module.exports = __webpack_public_path__ + "static/media/grip-horizontal.42fc459b.svg";